// extracted by mini-css-extract-plugin
module.exports = {"page":"layout_page__znzw3","content":"layout_content__ehK9O","contain":"layout_contain__KRZRf"};